(function() {
  var COOKIE_NAME = 'collection_unlocked';
  var COOKIE_DAYS = 30;

  function getUnlockedCollections() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return [];
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return [];
    }
  }

  function saveUnlockedCollections(list) {
    var expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_DAYS);
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(list)) + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  function unlockCollection(handle) {
    var list = getUnlockedCollections();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
    }
    saveUnlockedCollections(list);
  }

  function isUnlocked(handle) {
    return getUnlockedCollections().indexOf(handle) !== -1;
  }

  function init() {
    var gate = document.getElementById('collection-gate');
    if (!gate) return;

    var handle = gate.getAttribute('data-handle');
    var password = gate.getAttribute('data-password');
    var context = gate.getAttribute('data-context');

    if (isUnlocked(handle)) {
      gate.remove();
      // Remove the injected blur style
      var blurStyle = document.getElementById('collection-gate-blur');
      if (blurStyle) {
        blurStyle.remove();
      }
      return;
    }

    // Move gate to body to ensure it's always visible
    if (gate.parentElement !== document.body) {
      document.body.appendChild(gate);
    }

    // Show gate (content is already blurred by inline script)
    gate.style.display = '';

    // Add a class to body to indicate gate is active
    document.body.classList.add('collection-gate-active');

    var form = gate.querySelector('.collection-gate__form');
    var input = gate.querySelector('.collection-gate__input');
    var error = gate.querySelector('.collection-gate__error');

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var entered = input.value.trim();

      if (entered === password) {
        unlockCollection(handle);
        gate.remove();

        // Remove the injected blur style
        var blurStyle = document.getElementById('collection-gate-blur');
        if (blurStyle) {
          blurStyle.remove();
        }

        // Remove body class
        document.body.classList.remove('collection-gate-active');
      } else {
        error.style.display = '';
        input.value = '';
        input.focus();
      }
    });

    // Also submit on button click (in case onsubmit doesn't fire)
    var btn = gate.querySelector('.collection-gate__submit');
    btn.addEventListener('click', function() {
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    input.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
